// extracted by mini-css-extract-plugin
export default {"alarmTable":"AlarmRecord_alarmTable__rG9Gm","pagination":"AlarmRecord_pagination__-xPge","total":"AlarmRecord_total__FF9w9","pageContent":"AlarmRecord_pageContent__YGNWh"};